<strong mat-dialog-title class="confirm_title dialogText">
  {{ title }}
</strong>

<div mat-dialog-content class="dialogText" *ngIf="!isShowComment">
  <p>{{ message }}</p>
</div>
<div mat-dialog-content class="dialogText" *ngIf="isShowComment">
  <p [innerHTML]="message"></p>
</div>
<mat-form-field class="approveComment" *ngIf="isShowComment">
  <mat-label>Comment</mat-label>
  <textarea matInput [(ngModel)]="comment" rows="3" required minlength="5" #comments="ngModel"></textarea>
</mat-form-field>
<!---->
<div mat-dialog-actions class="padL16">
  <button name="no" mat-button (click)="onDismiss()">No</button>
  <button
    name="yes"
    mat-raised-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="isShowComment && (comment?.length || 0) < 5"
  >
    Yes
  </button>
</div>
